// utils/interactions.js
// Helpers for interactive messages: live-prompt bookkeeping and answer summaries.

// Only one interactive prompt is live per session. Mark every interactive message except the
// most recent one as superseded, so reloaded/older prompts render read-only.
export function lockStaleInteractions(messages) {
  let lastIdx = -1
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].messageType === 'interactive') { lastIdx = i; break }
  }
  messages.forEach((m, i) => {
    if (m.messageType === 'interactive' && i !== lastIdx) m.superseded = true
  })
}

// An interaction may be submitted only when it's still open: not answered locally, not superseded
// by a newer prompt, and not already resolved/cancelled server-side.
export function isInteractionOpen(msg) {
  if (!msg || msg.answered || msg.superseded) return false
  const status = msg.interaction?.status
  return status ? status === 'open' : true
}

function optionLabels(options, ids) {
  return (ids || [])
    .map(id => (options || []).find(o => o.id === id)?.label || id)
    .join(', ')
}

// Human-readable summary of an answer, used for both a fresh submit and a stored one.
export function summarizeAnswer(payload = {}, answer) {
  if (!answer) return ''

  if (Array.isArray(answer.optionIds) && answer.optionIds.length) {
    return `Seleccionaste: ${optionLabels(payload.options, answer.optionIds)}`
  }

  if (answer.fields && Object.keys(answer.fields).length) {
    const parts = Object.entries(answer.fields)
      .filter(([, v]) => v !== '' && v !== null && v !== undefined)
      .map(([k, v]) => {
        const field = (payload.fields || []).find(f => f.key === k)
        const label = field?.label || k
        const value = Array.isArray(v) ? v.join(', ') : (typeof v === 'boolean' ? (v ? 'Sí' : 'No') : v)
        return `${label}: ${value}`
      })
    return parts.length ? `Enviaste — ${parts.join(' · ')}` : 'Enviado'
  }

  if (answer.text) return `Respondiste: ${answer.text}`

  if (answer.decision) {
    const label = answer.decision === 'confirm'
      ? (payload.confirmLabel || 'Confirmar')
      : (payload.rejectLabel || 'Rechazar')
    return `Respondiste: ${label}`
  }

  return ''
}
